import { makeStyles, tokens } from "@fluentui/react-components";

export const appFeaturesCommonStyles = makeStyles({
  wrapper: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  container: {
    backgroundColor: tokens.colorNeutralBackground1,
    color: tokens.colorNeutralForeground1,
    flexDirection: 'column',
    padding: tokens.spacingHorizontalXL,
    overflowY: "auto",
    flex: 1,
  }
});